import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import * as Scopes from 'automation-ui-enrollment/constants/Scopes';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentAssistanceAlert(props) {
  const isSuperAdmin = useHasScope(Scopes.SUPER_ADMIN);
  return isSuperAdmin ? /*#__PURE__*/_jsx(Alert, Object.assign({
    type: "info",
    use: "inline"
  }, props, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'aiAssistantPanel.body.addActionsPanel.actionDescriptionSection.settingsAlert.superAdmin.contentAssistanceV2_jsx',
      elements: {
        Bold: 'strong',
        SettingsLink: ({
          children: linkChildren
        }) => /*#__PURE__*/_jsx(Link, {
          href: `/ai-settings/${PortalIdParser.get()}`,
          external: true,
          children: linkChildren
        })
      }
    })
  })) : null;
}